
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sou-cliente",
      function () {
        return require("private-next-pages/sou-cliente.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sou-cliente"])
      });
    }
  